import { BasePage } from '@/components/ui/base-page'

export function LendingPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add LendingPage specific content here */}
    </BasePage>
  )
}